// @core/api/endpoints/secret/update_kv_secret_metadata.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  KvSecretResponse,
  UpdateKvSecretMetadataRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Update KV secret metadata
 * Updates secret-level configuration: max_versions, cas_required, delete_version_after, and custom_metadata. Does not affect existing secret data.
 */
export async function UpdateKvSecretMetadata(
  engine_id: string,
  path: string,
  data: UpdateKvSecretMetadataRequest,
  options?: RequestOptions
): Promise<KvSecretResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/kv/metadata/:path`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':path', encodeURIComponent(path));
  const requestOptions = options;
  return client.patch<KvSecretResponse>(requestPath, data, requestOptions);
}
